import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeletePlanReviewFeedbackMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type DeletePlanReviewFeedbackMutation = { __typename?: 'mutation_root', delete_plan_review_feedback_by_pk?: { __typename?: 'plan_review_feedback', id: any } | null };


export const DeletePlanReviewFeedbackDocument = gql`
    mutation deletePlanReviewFeedback($id: uuid!) {
  delete_plan_review_feedback_by_pk(id: $id) {
    id
  }
}
    `;
export type DeletePlanReviewFeedbackMutationFn = Apollo.MutationFunction<DeletePlanReviewFeedbackMutation, DeletePlanReviewFeedbackMutationVariables>;

/**
 * __useDeletePlanReviewFeedbackMutation__
 *
 * To run a mutation, you first call `useDeletePlanReviewFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlanReviewFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlanReviewFeedbackMutation, { data, loading, error }] = useDeletePlanReviewFeedbackMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePlanReviewFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlanReviewFeedbackMutation, DeletePlanReviewFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlanReviewFeedbackMutation, DeletePlanReviewFeedbackMutationVariables>(DeletePlanReviewFeedbackDocument, options);
      }
export type DeletePlanReviewFeedbackMutationHookResult = ReturnType<typeof useDeletePlanReviewFeedbackMutation>;
export type DeletePlanReviewFeedbackMutationResult = Apollo.MutationResult<DeletePlanReviewFeedbackMutation>;
export type DeletePlanReviewFeedbackMutationOptions = Apollo.BaseMutationOptions<DeletePlanReviewFeedbackMutation, DeletePlanReviewFeedbackMutationVariables>;